module.exports = __webpack_public_path__ + "img/courses-workshop.466661d7.svg";